module.exports = __webpack_public_path__ + "img/send-email-envelope.190283f8.svg";